import moment from 'moment';
export default class TimeFormat {
    // Users
    formatDate(date) {
        if (date) {
            const longDate = moment(date);
            return moment(longDate['_d']).format('MM-DD-YYYY hh:mm');
        }
    }
}
